import { HStack, Spinner } from "@chakra-ui/react";
import { formatDistanceToNow } from "date-fns";
import { useEffect, useState } from "react";
import CDS from "design-system";

export type AutosaveState =
  | { kind: "idle" }
  | { kind: "saving" }
  | { kind: "saved"; at: Date }
  | { kind: "error" };

interface Props {
  state: AutosaveState;
}

// Refresh the "Saved <N> ago" copy every 30s so the timestamp doesn't freeze.
function useTick(intervalMs: number) {
  const [, setTick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
}

export default function AutosaveIndicator({ state }: Props) {
  useTick(30_000);

  if (state.kind === "saving") {
    return (
      <HStack spacing={2} color="content.tertiary">
        <Spinner size="xs" />
        <CDS.Text12 color="content.tertiary">Saving…</CDS.Text12>
      </HStack>
    );
  }

  if (state.kind === "saved") {
    const suffix = formatDistanceToNow(state.at, { addSuffix: true });
    return (
      <CDS.Text12 color="content.tertiary">
        Saved {suffix.replace("less than a minute ago", "just now")}
      </CDS.Text12>
    );
  }

  if (state.kind === "error") {
    return <CDS.Text12 color="content.negative">Save failed</CDS.Text12>;
  }

  return null;
}
